import AxiosApiInstance, {APIBase} from "../../../../AxiosApiInstance";
import {AxiosResponse} from "axios";
import {LimitOffsetGetRequest} from "../../../../DefaultGetRequest";
import DefaultGetResponse from "../../../../DefaultGetResponse";
import ApiProgramConfigGet from "./ApiProgramConfigGet";

const ApiBackCampaignsConfigsProgramsGet
  = (campaign_pk: string, params?: LimitOffsetGetRequest)
  :Promise<AxiosResponse<DefaultGetResponse<ApiProgramConfigGet>>> => {
    return AxiosApiInstance.get(`${APIBase}back/campaigns/${campaign_pk}/configs/programs/`, {
      params: params
    });
  };

export default ApiBackCampaignsConfigsProgramsGet;